import React, { useEffect, useRef, useState } from 'react'
import './slidercontrol.css'
import './sliders.css'

// Slider Delay
const TIMEOUT = 100;
/**
 * Renders a slider input with a text box for value input.
 * This component allows users to adjust a value using a slider and see the current value in a text box, or enter a value directly into the text box.
 * I had to throw in a delay because React will throw an error if the value changes too often (TIMEOUT)
 * @param {Object} props - 
 * @param {string} props.id - The unique identifier for the slider.
 * @param {string} props.name - The name of the slider input. This is passed to the input so the form can use it.
 * @param {string} props.title - The title label for the slider.
 * @param {number} props.value - This will be the initial value of the slider and the text box.
 * @param {number} props.min - The minimum value of the slider.
 * @param {number} props.max - The maximum value of the slider.
 * @param {function} props.onSliderUpdate - Callback function to handle slider value updates.
 * @returns {JSX.Element} The rendered SliderControl component.
 */
const SliderControl = ({ id, name, title, value, min, max, onSliderUpdate }) => {
    // * React will throw an error if the value changes too often so we use a timeout inside onChange handler. 
    // The timeout is TIMEOUT ms. tymeout holds the timeout ID so we can clear it if needed, and use it to check if we are waiting for one.
    const [ tymeout, setTymeout ] = useState(null);
    const [inputValue, setInputValue] = useState(value);
    const sliderRef = useRef(null);
    
    function handleChange(event){
        if (tymeout) return;
        setTymeout( setTimeout( ()=> {            
            onSliderUpdate(event, event.target);            
            setTymeout(null);
        }, TIMEOUT) );
    }

    function onInputChange(event){
        const inpt = event.target;
        //onSliderUpdate(event, event.target);
        onSliderUpdate(null, event.target);
    }

    useEffect(()=>{
        setInputValue(value);
    }, [value])

    useEffect(()=>{
        sliderRef.current.value = value;
    }, [sliderRef])

    return (
        <div className='slider-container'>
            <label className='slider-label'>{title}</label>
            <input
                ref={sliderRef}
                data-id={id}
                name={name}
                onChange={handleChange}
                type='range'
                className='slider'
                min={min} max={max}
                step={2}
            ></input>
            <input 
                type='text'
                data-id={id}
                name={name}                
                className='box'
                value={inputValue}
                onChange={onInputChange}
            />
        </div>
    )
}

export default SliderControl